import { Close } from "@mui/icons-material"
import { AppBar, Card, Grid, IconButton, Toolbar } from "@mui/material"
import { TCLabel, TCTitleLabel } from "components/TopCourtComponents/Label/TopCourtLabel"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { getAddOnHistory } from "services/addonServices"

function AddOnEditHistory ({
    id,
    setClose
}) {
    const [ historyData, setHistoryData ] = useState([])
    
    useEffect(() => {
        loadAddOnHistory()
    }, [])

    const loadAddOnHistory = async () => {
        let { data, error } = await getAddOnHistory(id)
        if (error) { console.log(error) }
        if (data) { 
            console.log('here data', data)
            setHistoryData(data) 
        }
    }

      return (
          <div
              style={{
                minWidth: (window.innerWidth < 500) ? '100vw' : '40vw',
                maxWidth: (window.innerWidth < 500) ? '100vw' : '40vw',
                overflow: 'auto'
              }}>
              <AppBar style={{
                maxWidth: (window.innerWidth < 500) ? '100vw' : '40vw',
                backgroundColor: '#0198E1'
              }}>
                <Toolbar style={{ maxHeight: '55px', minHeight: '55px' }}>
                  <IconButton edge="start" color="inherit" aria-label="close" onClick={() => {
                    setClose()
                  }}>
                    <Close />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <Grid xs={12} p={2} pt={8}>
              {
                  historyData && historyData.map((value, index) => {
                      return (<Card style={{ marginBottom: 10, border: '1px solid rgba(0, 0, 0, 0.1)' }} key={index}>
                          <Grid xs={12} p={1}>
                              <div style={{fontSize: 10, color: 'grey'}}>{moment(value.createdDate).format('YYYY/MM/DD HH:mm:ss')}</div>
                              {value.admin && <div style={{fontSize: 12, fontWeight: 'bold'}}>{`${value.admin.name} edit Status Add-On`}</div>}
                              <div style={{display: 'flex'}}>
                                  {
                                  <div style={{width: '50%'}} key={`${value._id}oldValue`}>
                                      <div style={{fontSize: 10, color: 'grey'}}>
                                          Old Value:
                                      </div>
                                      {
                                          value.oldValue.length > 0 &&
                                          Object.keys(value.oldValue[0])[0] ? 
                                          value.oldValue.map((userInfoValue, index) => {
                                              return (
                                              <div style={{fontSize: 12}} key={`${index}userInfoOldValue`}>
                                                  {
                                                    (Object.keys(userInfoValue)[0] != null || Object.keys(userInfoValue)[0] != undefined) ?
                                                        logValueCustomator(userInfoValue, false, true)
                                                    :
                                                        logValueCustomator(value.newUserInfo[index], true, true)
                                                  }
                                              </div>
                                              )
                                          })
                                      :
                                          value.newValue.map((userInfoValue, index) => {
                                              return (
                                              <div style={{fontSize: 12}} key={`${index}userInfoOldValue`}>
                                                  {logValueCustomator(userInfoValue , true, true)}
                                              </div>
                                              )
                                          })
                                      }
                                  </div>
                                  }
                                  <div style={{width: '50%'}} key={`${value._id}newValue`}>
                                  <div style={{fontSize: 10, color: 'grey'}}>
                                      New Value:
                                  </div>
                                  {
                                      value.newValue.length > 0 &&
                                      value.newValue.map((userInfoValue, index) => {
                                          return (
                                              <div style={{fontSize: 12}} key={`${index}userInfoNewValue`}>
                                              {logValueCustomator(userInfoValue, false, false)}
                                              </div>
                                          )
                                      })
                                  }
                                  </div>
                              </div>
                          </Grid>
                      </Card>)
                  })
              }
              {
                  (!historyData || historyData.length == 0) &&
                  <Grid xs={12} >
                      <TCLabel bold>No Data</TCLabel>
                  </Grid>
              }
              </Grid>
          </div>
      )
}

function logValueCustomator(value, empty = false, oldValue = false) {
  let keysCustomated = Object.keys(value)[0]
  let valueCustomated = value[Object.keys(value)[0]]
  let data = []
  if (Object.keys(value)[0] === "name") {
    keysCustomated = "Name"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }
  if (Object.keys(value)[0] === "price") {
    keysCustomated = "Price"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }
  if (Object.keys(value)[0] === "type") {
    keysCustomated = "Add-On Type"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }
  if (Object.keys(value)[0] === "stock") {
    keysCustomated = "Stock"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }
  if (Object.keys(value)[0] === "validity") {
    keysCustomated = "Advanced Booking"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }
  if (Object.keys(value)[0] === "isActive") {
    console.log('here check value',keysCustomated, Object.keys(value)[0], value)
    keysCustomated = "Status"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated.toString() == "true" ? "True" : "False"}</div>)
  }
  if (Object.keys(value)[0] === "lockSchedule") {
    console.log('here check value',keysCustomated, Object.keys(value)[0], value)
    keysCustomated = "Lock Edit"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated.toString() == "true" ? "True" : "False"}</div>)
  }
  if (Object.keys(value)[0] === "itemImages") {
    keysCustomated = "Images"
    data.push(
      {
        ...valueCustomated && valueCustomated[0] ?
          <div key={Object.keys(value)[0]} className='d-flex mb-1' style={{ textAlign: 'left' }}>
            <img src={(valueCustomated[0].includes("https")) ? valueCustomated[0] : URL.createObjectURL(valueCustomated[0])} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
              alt=''
            />
          </div>
        : <div key={Object.keys(value)[0]}>{'No value'}</div>
      }
      
    )
  }
  if (Object.keys(value)[0] === "description") {
    console.log('here check value',keysCustomated, Object.keys(value)[0], value)
    keysCustomated = "Description"
    let desc = `${keysCustomated} : ${valueCustomated ? valueCustomated : 'No value'}`
    data.push(<div key={Object.keys(value)[0]} dangerouslySetInnerHTML={{ __html: desc }}></div>)
  }
  if (Object.keys(value)[0] === "user") {
    console.log('here check value',keysCustomated, Object.keys(value)[0], value)
    keysCustomated = "User"
    data.push(<div key={Object.keys(value)[0]}>{keysCustomated} : {valueCustomated ? valueCustomated : 'No value'}</div>)
  }

  if (empty) {
    return (
      <div>
        {keysCustomated} : No value
      </div>
    )
  }
  return (data)
}

export default AddOnEditHistory